import axiosInstance from "./service-instance";
import QueryString from "query-string";

export default {
    fetchDBList: (stage, page, page_size, filters)  =>   axiosInstance.get(`/workflow/action-detail/db-list/?${QueryString.stringify({...filters})}`, {
            params: {
                stage,
                page,
                page_size,
                reverse : true 
            }
        }),
    fetchDbListCount : ({type = null} = {}) => axiosInstance.get(`/workflow/action-detail/db-list-count/` , {
        params :{
            type : type || undefined
        }
    }),
    fetchUserList : (stage_id ,company_id , action_task_id) => axiosInstance.get(`/workflow/action-task/movement/user-list/` , {
        params : {
            stage_id : stage_id,
            type : 'proceed' , 
            company_id : company_id,
            action_task_id : action_task_id
        }
    }),
    referBack : (stage_id ,company_id , action_task_id) => axiosInstance.get(`/workflow/action-task/movement/user-list/` , {
        params : {
            stage_id : stage_id,
            type : 'refer' , 
            company_id : company_id,
            action_task_id : action_task_id
        }
    }),
    proceedCase : (data , type) => axiosInstance.post(`/workflow/action-task/proceed/?type=${type}`, data),
    validateDocumentDB: (company_id, document_id, data) =>
        axiosInstance.put(`/company/${company_id}/document-master/${document_id}/detail/`, data),
    cibilDownload : (associate) => {
        return axiosInstance.get(`/cibil/pdf/?associate=${associate}`)
    },
    assignCase: (action_task_id, remarks, user) =>
        axiosInstance.post(`workflow/action-task/assignment/${action_task_id}/`,
            {
                action_remarks: remarks,
                this_user: user
            }
        ),
};